import styled from '@emotion/styled';

export const Root = styled.p`
  display: -webkit-box;
  color: inherit;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
